import { createReducer } from '@reduxjs/toolkit';

const initialState= {
	commonDropDown  : { sts:false,msg:'Inti call',rslt:[],error:[] },
	careerAddUpdate : { sts:false,msg:'Inti call',rslt:[],error:[] },
	addUpdate       : { sts:false,msg:'Inti call',rslt:[],error:[] }
};

const returnData=(state,action)=>{
	let callFrm = action.type.split('/')[0];
	if(action.payload){
		let result = action.payload;
		Object.keys(result).map((keyVal)=>{
			state[String(callFrm)] = { ...state[String(callFrm)],[String(keyVal)] : result[String(keyVal)] };
			return true;
		});
	}else{
		state[String(callFrm)] = { sts:false,msg:'Inti payload fail',rslt:[],error:[] };
	}
};

const reducers = createReducer(initialState,(builder)=>{ builder
	.addCase('commonDropDown/fulfilled',(state,action)=>{ returnData(state,action);})
	.addCase('careerAddUpdate/fulfilled',(state,action)=>{ returnData(state,action);})
	.addCase('addUpdate/fulfilled',(state,action)=>{ returnData(state,action);});
});
export default reducers;
